import { render, staticRenderFns } from "./AddLocation.vue?vue&type=template&id=74f12b50&scoped=true"
import script from "./AddLocation.vue?vue&type=script&lang=js"
export * from "./AddLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f12b50",
  null
  
)

export default component.exports